// @mui
import { Box, Stack } from '@mui/material';
// config
import { NAV } from '../../../config-global';
// utils
import { hideScrollbarX } from '../../../utils/cssStyles';
// components
import { NavListProps, NavSectionMini } from '../../../components/nav-section';
//
import NavToggleButton from './NavToggleButton';
import { createNavConfig } from './config-navigation';
import { useGetConfigurationQuery } from '../../../redux/slices/apiSlice';
import { useAuthContext } from '../../../auth/useAuthContext';
// ----------------------------------------------------------------------

export default function NavMini() {
  const { data, isSuccess, error } = useGetConfigurationQuery();
  const { user } = useAuthContext();
  let localNavConfig: {
    subheader: string;
    items: NavListProps[];
  }[] = [];

  if (isSuccess) {
    console.log(`### configuration: ${JSON.stringify(data)}`);
    if (data) {
      localNavConfig = createNavConfig(data, user);
    }
  } else {
    console.log(`### Error loading configuration: ${error}`);
  }

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD_MINI },
      }}
    >
      <NavToggleButton
        sx={{
          top: 22,
          left: NAV.W_DASHBOARD_MINI - 12,
        }}
      />

      <Stack
        sx={{
          pb: 2,
          height: 1,
          position: 'fixed',
          width: NAV.W_DASHBOARD_MINI,
          borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          ...hideScrollbarX,
        }}
      >
        <NavSectionMini data={localNavConfig} />
      </Stack>
    </Box>
  );
}
